import React, {
    useState,
} from 'react';
import { useHistory } from 'react-router';

type Setting = {
    loginConfig: {
        isRemember: boolean,
        isAutoLogin: boolean,
    },
    loginInfo: {
        login: string,
        password: string,
        expiryDate: number,
    },
};

export type SettingProviderValue = {
    setting: Setting,
    setSetting: (setting: Partial<Setting>) => void,
};

const DEFAULT_SETTING: Setting = {
    loginConfig: {
        isRemember: false,
        isAutoLogin: false,
    },
    loginInfo: {
        login: '',
        password: '',
        expiryDate: 0,
    },
};

export const SettingContext: React.Context<SettingProviderValue> = React.createContext({
    setting: DEFAULT_SETTING,
} as SettingProviderValue);

interface SettingProviderProps {
    children: React.ReactNode,
}

const KEY = 'ucpt-setting';

export function SettingProvider(props: SettingProviderProps): React.ReactElement {
    const {
        children,
    } = props;
    const history = useHistory();

    const [settingData, setSettingData] = useState<Setting>(getSettingFromLocationStorage());

    function getSettingFromLocationStorage(): Setting {
        const settingString = localStorage.getItem(KEY);
        if (settingString) {
            try {
                const storageSetting = JSON.parse(settingString) as Setting;
                return {
                    ...DEFAULT_SETTING,
                    ...storageSetting,
                };
            } catch (e) {
                return DEFAULT_SETTING;
            }
        }

        return DEFAULT_SETTING;
    }

    function setSetting(setting: Partial<Setting>) {
        const oldSetting = getSettingFromLocationStorage();
        const newSetting = {
            ...oldSetting,
            ...setting,
        };
        setSettingData(newSetting);
        localStorage.setItem(KEY, JSON.stringify(newSetting));
    }

    return (
        <SettingContext.Provider
            value={{
                setting: settingData,
                setSetting,
            }}
        >
            {children}
        </SettingContext.Provider>
    );
}
